import GedTypeRepository from '@/shared/http/repositories/business/gedtype'
import ActionsForm from '@/shared/mixins/actionsForm'
import gedTypeModel from '@/shared/models/business/gedtypemodel'
import { loading } from '@/shared/utils/UIHelper'
import addTypeForm from './addtype-form'

export default {
  name: 'AddType',
  mixins: [ActionsForm],
  data () {
    return {
      data: gedTypeModel,
      form: addTypeForm
    }
  },
  created () {
    this.onClear()
  },
  methods: {
    onLoad () {
      loading.push()
      GedTypeRepository.GetAll()
        .then(response => {
          this.onResultGrid(response)
        })
        .catch(err => this.onException(err))
    },
    onCreate () {
      loading.push()
      GedTypeRepository.Create(this.data)
        .then(response => {
          this.onResult(response)
        })
        .catch(err => this.onException(err))
    },
    onUpdate () {
      loading.push()
      this.data.status = parseInt(this.data.status)
      GedTypeRepository.Update(this.data)
        .then(response => {
          this.onResult(response)
        })
        .catch(err => this.onException(err))
    },
    onDelete (obj) {
      loading.push()
      GedTypeRepository.Delete(obj.id)
        .then(response => {
          this.onResult(response)
        })
        .catch(err => this.onException(err))
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/type/addtype.js